// "Mượn / trả đồ" — máy quét nằm ngay trong GNPF (CEO chốt 08/10/2026 1a·2a·3a,
// 1a·2c). Lệnh đi qua Center về kho thiết bị; kho tự kiểm rồi trả kết quả.

import type { GuideBook } from "../types";

const EVERYONE = [
  "reception",
  "sale",
  "photo",
  "makeup",
  "assistant",
  "retouch",
  "cskh",
  "marketing",
  "accounting",
  "qc",
  "lead",
  "exec",
] as const;

export const KHO_BORROW_GUIDES: GuideBook = {
  muon_tra_do: {
    purpose: "Mượn hoặc trả thiết bị của kho bằng camera điện thoại, ngay trong GNPF.",
    where: [
      'Mục "Mượn / trả đồ" trong nhóm "Của tôi" trên menu, ngay trên "Thông báo của tôi".',
      'Màn đầu: hai nút lớn "Mượn đồ" và "Trả đồ", bên dưới là danh sách "Đồ bạn đang mượn" kèm hạn trả.',
      'Bước quét: khung camera ở giữa, ô "Hoặc gõ mã trên tem" bên dưới, danh sách "Đã quét … món" và nút "Gửi về kho".',
      'Khi trả: mỗi món có các nút tình trạng (Bình thường · Bẩn · Hỏng · Thiếu phụ kiện · Mất), nút "Chụp ảnh" và ô ghi chú.',
    ],
    howItWorks: [
      "Camera mở ngay trên trang; lần đầu máy hỏi quyền dùng camera — bấm Cho phép.",
      "Phải quét tờ mã dán ở cửa kho trước: đó là bằng chứng bạn đang đứng ở kho, nên không ai mượn hộ từ xa được.",
      "Tên và tình trạng món hiện ngay từ bản sao kho trong GNPF; kho thiết bị mới là nơi quyết định.",
      'Bấm "Gửi về kho" là cả giỏ đi thành MỘT yêu cầu, qua Center tới kho. Kho tự kiểm tờ mã, quyền vào cơ sở và từng món rồi trả kết quả — không ai phải bấm duyệt.',
      "Một món sai thì kho KHÔNG ghi món nào (cả giỏ), và nói rõ lý do từng món — sửa giỏ rồi gửi lại.",
      "Trả đồ: món nào cũng cần ít nhất 1 ảnh; báo mất thì không cần ảnh nhưng phải ghi chuyện gì đã xảy ra.",
      'Mượn ở đây thì hạn trả tự là 23:59 hôm nay. Cần giữ lâu hơn: mở mục "Kho", phần "Đồ tôi đang giữ", bấm "Xin gia hạn".',
      "Sổ mượn/trả nằm ở kho thiết bị. Thư báo mượn/trả gửi về email của bạn.",
    ],
    statuses: [
      { label: "Đang tra… / Trong kho / Bạn đang giữ", meaning: "Tình trạng món theo bản sao kho trong GNPF, để bạn biết trước." },
      { label: "Đang ghi người khác", meaning: "Theo bản sao, món đang ghi tên người khác; kho vẫn cho mượn và báo người cũ." },
      { label: "Chưa có trong bản sao", meaning: "GNPF chưa biết món này (thường là món của cơ sở khác); vẫn gửi được, kho tự tra." },
      { label: "Kho đang ghi…", meaning: "Yêu cầu đang đi qua Center về kho; đứng chờ, chưa mang đồ đi." },
      { label: "Đã mượn … món / Đã trả … món", meaning: "Kho đã ghi xong; danh sách món hiện ngay dưới." },
      { label: "Chưa mượn món nào / Chưa trả món nào", meaning: "Kho từ chối cả giỏ; xem lý do ghi dưới từng món." },
      { label: "Quá 1 phút chưa có kết quả", meaning: "Center hoặc kho đang trục trặc; yêu cầu vẫn được giữ và tự gửi lại, không mượn trùng." },
    ],
    blocks: [
      {
        for: [...EVERYONE],
        title: "Mượn hoặc trả đồ",
        steps: [
          "Đứng ở cửa kho, mở GNPF trên điện thoại.",
          'Bấm "Mượn / trả đồ" trên menu, chọn "Mượn đồ" hoặc "Trả đồ".',
          "Quét tờ mã dán ở cửa kho.",
          "Quét tem từng món. Trả đồ: chọn tình trạng và bấm \"Chụp ảnh\" cho từng món.",
          'Bấm "Gửi về kho", đứng chờ kết quả.',
          'Thấy "Đã mượn" / "Đã trả" thì mang đồ đi hoặc để đồ lại kho.',
        ],
        troubles: [
          'Màn báo "Đây không phải tờ mã cửa kho": bạn vừa quét tem món hoặc mã khác — quét tờ dán ở cửa.',
          "Không mở được camera: cho phép trình duyệt dùng camera, hoặc gõ mã in trên tem vào ô bên dưới.",
          "Kho báo tờ mã không đúng: tờ đã được in lại — quét tờ đang dán ở cửa, hoặc báo thủ kho.",
          "Kho báo bạn chưa được gắn cơ sở này: nhờ quản lý cơ sở gắn thêm cơ sở cho bạn.",
          "Quá 1 phút chưa có kết quả: chờ thêm; vẫn kẹt thì quét tờ mã bằng camera thường để mở trang kho dự phòng.",
        ],
      },
      {
        for: ["lead", "exec"],
        title: "Theo dõi đồ của cơ sở",
        steps: [
          'Mở mục "Kho" để xem đồ của cơ sở, ai đang giữ, món quá hạn.',
          "Món kho báo \"đang ghi người khác\" khi có người mượn: kho đã gửi thư cho người cũ; kiểm lại với họ nếu cần.",
        ],
        troubles: ["Số liệu chưa khớp ngay: bản sao kho cập nhật sau vài giây tới vài phút."],
      },
    ],
    askWho: "Hỏi về đồ đạc, tờ mã, việc mượn trả thì hỏi thủ kho cơ sở.",
  },
};
